/* eslint-disable camelcase */
import React from 'react';

import { InputText, Dropdown } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { AUS_States } from '@PetSureAustralia/petsure-react-ui-library/distLib/utilities/Australia/States';

import './addressManualEntryPanel.scss';
import PropTypes from 'prop-types';

export const AddressManualEntryPanel = ({ fieldFormContext }) => {
  return (
    <fieldset className="addressManualEntryPanel">
      <InputText
        {...{
          fieldFormContext,
          label: 'Street address',
          name: 'streetAddress',
          validation: { required: 'This field is required.' },
          customCssClass: 'streetAddressField'
        }}
      />

      <Dropdown
        {...{
          fieldFormContext,
          label: 'Suburb',
          name: 'suburb',
          validation: { required: 'This field is required.' },
          customCssClass: 'suburbField'
        }}
      />

      <Dropdown
        {...{
          fieldFormContext,
          label: 'State',
          name: 'state',
          validation: { required: 'This field is required.' },
          customCssClass: 'stateField',
          options: AUS_States
        }}
      />

      <InputText
        {...{
          fieldFormContext,
          label: 'Postcode',
          name: 'postcode',
          validation: { required: 'This field is required.' },
          customCssClass: 'postcodeField'
        }}
      />
    </fieldset>
  );
};

AddressManualEntryPanel.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fieldFormContext: PropTypes.any
};
